import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-46bcc392"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "h-[550px] bg-banner bg-opPrimary text-opWhite flex justify-center items-center" }
const _hoisted_3 = { class: "leading-[64px]" }
const _hoisted_4 = { class: "m-[16px 0] leading-[64px]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "object-cover rounded-t-xl w-[370px] 2xl:w-[480px]",
  src: _imports_0,
  alt: "SF API"
}, null, -1))
const _hoisted_6 = { class: "h-[500px] bg-opWhite flex justify-center items-center flex-col" }
const _hoisted_7 = { class: "text-opTextFirst text-[32px] text-center mb-[10px]" }
const _hoisted_8 = { class: "text-opTextSecond max-w-[750px] text-left" }
const _hoisted_9 = { class: "flex justify-center" }
const _hoisted_10 = { class: "text-[24px] mb-[12px] mt-[30px] text-opTextFirst" }
const _hoisted_11 = { class: "max-w-[250px] text-[14px] text-opTextSecond text-left" }
const _hoisted_12 = { class: "h-[700px] bg-capabilityList text-opWhite flex justify-center items-center flex-col" }
const _hoisted_13 = { class: "text-[32px] text-center mb-[10px]" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "flex justify-center mt-[60px]" }
const _hoisted_16 = ["onMouseenter"]
const _hoisted_17 = { class: "w-full" }
const _hoisted_18 = { class: "flex justify-between items-center text-[22px]" }
const _hoisted_19 = { class: "flex items-center" }
const _hoisted_20 = { class: "ml-[15px]" }
const _hoisted_21 = { class: "text-opTextSecond text-[24px]" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "h-[2px] border-b-2 mt-[20px] mb-[30px] border-opTextSecond" }, null, -1))
const _hoisted_23 = { class: "text-[14px] text-left line leading-7" }
const _hoisted_24 = { class: "w-full flex justify-around" }
const _hoisted_25 = { class: "h-[590px] bg-accesstype flex justify-center items-center flex-col text-opTextFirst" }
const _hoisted_26 = { class: "text-[32px] text-center mb-[60px]" }
const _hoisted_27 = { class: "flex justify-center" }
const _hoisted_28 = {
  class: "flex flex-col items-center",
  style: {"width":"max-content"}
}
const _hoisted_29 = { class: "text-[24px] mb-[12px] mt-[30px] text-opTextFirst" }
const _hoisted_30 = { class: "max-w-[250px] text-[14px] text-opTextSecond text-left" }
const _hoisted_31 = { class: "max-w-[250px] text-[14px] text-opTextSecond text-left" }
const _hoisted_32 = { class: "w-full flex justify-around" }
const _hoisted_33 = { class: "h-[600px] bg-opWhite" }
const _hoisted_34 = { class: "h-[500px] flex flex-col justify-center items-center" }
const _hoisted_35 = { class: "text-[32px] text-center mb-[60px]" }
const _hoisted_36 = { class: "flex justify-center" }
const _hoisted_37 = { class: "flex flex-col items-center" }
const _hoisted_38 = { class: "process-logo" }
const _hoisted_39 = { class: "flex items-center justify-start" }
const _hoisted_40 = { class: "mr-[8px] italic font-semibold text-opSecondary" }
const _hoisted_41 = { class: "xl:max-w-[200px] text-center" }
const _hoisted_42 = {
  key: 0,
  class: "w-[135px] bg-processline mx-[15px] 2xl:mx-[30px]"
}
const _hoisted_43 = { class: "h-[100px] bg-process flex items-center justify-center text-opWhite" }
const _hoisted_44 = { class: "text-[28px] mr-[50px]" }

import Axios from 'axios'
import { onMounted, reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useAppStore } from '@/stores/app'
// import { firstMenuListType } from '@/views/DocumentView.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {

const router = useRouter()
const { t, locale } = useI18n()
const app = useAppStore()
const isZh = locale.value === 'zh-CN'

const customColor = reactive({
  opPrimary: '',
  opSecondary: ''
})
onMounted(() => {
  !app.customColor.opPrimary && app.genCustomColor()
  customColor.opPrimary = app.customColor.opPrimary
  customColor.opSecondary = app.customColor.opSecondary
//   app.getAppData()
})

const resourceList = [
  {
    logo: 'Group98',
    title: t('slogaRich'),
    content: t('slogaRichContent')
  },
  {
    logo: 'Group95',
    title: t('slogaRich1'),
    content: t('slogaRichContent1')
  },
  {
    logo: 'Group97',
    title: t('slogaRich2'),
    content: t('slogaRichContent2')
  },
  {
    logo: 'Group96',
    title: t('slogaRich3'),
    content: t('slogaRichContent3')
  }
]
const accesstypeList = [
  {
    logo: 'Group413',
    title: t('shop'),
    content: t('shopContent'),
    content2: t('shopContent2'),
    docList: [
      { name: t('accessnowBtn'), func: () => { jumpToConsole() } },
      { name: t('viewAccessDocuments'), func: () => { jumpToGuide(process.env.VUE_APP_DOC_GUID_MENUID_CUST) } }
    ]
  },
  {
    logo: 'Group420',
    title: t('thirdErp'),
    content: t('thirdErpCotent'),
    content2: t('thirdErpCotent2'),
    docList: [
      { name: t('accessnowBtn'), func: () => { jumpToConsole() } },
      { name: t('viewAccessDocuments'), func: () => { jumpToGuide(process.env.VUE_APP_DOC_GUID_MENUID_ERP) } }
    ]
  },
  {
    logo: 'Group421',
    title: t('logisticspartner'),
    content: t('logisticspartnerCotent'),
    content2: t('logisticspartnerCotent2'),
    docList: [
      { name: t('accessnowBtn'), func: () => { jumpToConsole() } },
      { name: t('viewAccessDocuments'), func: () => { jumpToGuide(process.env.VUE_APP_DOC_GUID_MENUID_ERP_USER) } }
    ]
  }
]

const processList = [
  {
    logo: 'Group128',
    content: t('precess1'),
    islast: false
  },
  {
    logo: 'Group129',
    content: t('precess2'),
    islast: false
  },
  {
    logo: 'Group130',
    content: t('precess3'),
    islast: false
  },
  {
    logo: 'Group131',
    content: t('precess4'),
    islast: true
  }
]

const capacityList = reactive<Record<string, any>[]>([])
const isOvercapacityItemIndex = ref<string|number>('')
const capicityLogoMap = {
  1: {
    name: 'Group111',
    width: 42,
    height: 42
  },
  2: {
    name: 'Group112',
    width: 42,
    height: 42
  },
  3: {
    name: 'Group113',
    width: 42,
    height: 42
  },
  4: {
    name: 'Group114',
    width: 42,
    height: 42
  }
}
const getCapacityList = async () => {
  const { data: ResData } = await Axios.get(`/openapi/console/noLogin/openness/service/list?time=${new Date().getTime()}`)
  ResData.data?.forEach((item:Record<string, number|string>, index:number) => {
    capacityList.push({
      name: isZh ? item.nameCn : item.nameEn,
      desc: isZh ? item.descCn : item.descEn,
      logo: capicityLogoMap[++index] ?? capicityLogoMap[2],
      docList: item.docList
    })
  })
}
getCapacityList()
const jumpByCapacity = (item) => {
  router.push({
    path: '/document',
    query: {
      firstMenu: 'API',
      secondMenu: item.menuId
    }
  })
}

const jumpToDoc = () => {
  router.push({
    path: '/document',
    query: {
      firstMenu: 'DOC',
      secondMenu: ''
    }
  })
}

const jumpToGuide = (menuId:string) => {
  router.push({
    path: '/document',
    query: {
      firstMenu: 'GUIDE',
      secondMenu: menuId
    }
  })
}
const jumpToQs = () => {
  router.push({
    path: '/question'
  })
}
const jumpToConsole = () => {
  window.open(`${process.env.VUE_APP_CONSOLE_URL}?lang=${locale.value}`, '_blank')
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_svg_icon = _resolveComponent("svg-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(isZh?
                ['max-w-[600px]', '2xl:max-w-[800px]', 'text-[40px]','mr-[75px]','2xl:mr-[150px]']:
                ['max-w-[800px]', '2xl:max-w-[850px]', 'text-[37px]','mr-[50px]','2xl:mr-[100px]'])
      }, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('sysName')), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)('slogan')), 1),
        _createElementVNode("div", {
          class: _normalizeClass(isZh?`text-[24px]`:`text-[22px]`)
        }, _toDisplayString(_unref(t)('slogan1')), 3),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: jumpToConsole
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('accessNow')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            class: "doc-btn",
            onClick: _cache[0] || (_cache[0] = ()=>jumpToDoc())
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('tDocument')), 1)
            ]),
            _: 1
          })
        ])
      ], 2),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(t)('resourceAdvantages')), 1),
        _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('slogan2')), 1)
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(resourceList, (item, key) => {
          return _createElementVNode("div", {
            key: key,
            class: "flex flex-col items-center m-[25px] 2xl:m-[50px]"
          }, [
            _createVNode(_component_svg_icon, {
              name: item.logo,
              width: 80,
              height: 80,
              color: ""
            }, null, 8, ["name"]),
            _createElementVNode("div", _hoisted_10, _toDisplayString(item.title), 1),
            _createElementVNode("div", _hoisted_11, _toDisplayString(item.content), 1)
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_13, _toDisplayString(_unref(t)('capabilityList')), 1),
        _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(t)('capabilityListContent')), 1)
      ]),
      _createElementVNode("div", _hoisted_15, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(capacityList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: _normalizeClass(["w-[300px] h-[385px] p-[25px] flex flex-col items-center justify-between m-[12px] 2xl:m-[12px]", [`bg-capability${index+1}`]]),
            onMouseenter: ()=>{isOvercapacityItemIndex.value=index},
            onMouseleave: _cache[1] || (_cache[1] = ()=>{isOvercapacityItemIndex.value=''})
          }, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_svg_icon, {
                    name: item.logo.name,
                    width: item.logo.width,
                    height: item.logo.height,
                    color: ""
                  }, null, 8, ["name", "width", "height"]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1)
                ]),
                _createElementVNode("div", _hoisted_21, _toDisplayString(index+1), 1)
              ]),
              _hoisted_22,
              _createElementVNode("div", _hoisted_23, _toDisplayString(item.desc), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.docList, (subTtem, subIndex) => {
                return (_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  class: _normalizeClass(["capacity-btn", [isOvercapacityItemIndex.value===index&&'hover-btn']]),
                  key: subIndex,
                  onClick: ()=>jumpByCapacity(subTtem)
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isZh?subTtem.nameCn:subTtem.nameEn), 1)
                  ]),
                  _: 2
                }, 1032, ["class", "onClick"]))
              }), 128))
            ])
          ], 42, _hoisted_16))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(t)('accesstype')), 1),
      _createElementVNode("div", _hoisted_27, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(accesstypeList, (item, key) => {
          return _createElementVNode("div", {
            key: key,
            class: "w-[380px] h-[320px] bg-opWhite m-[15px] rounded-[12px] py-[20px] px-[50px] flex flex-col items-center justify-around transition-transform transform hover:translate-y-2 hover:scale-105 hover:shadow-md"
          }, [
            _createElementVNode("div", _hoisted_28, [
              _createVNode(_component_svg_icon, {
                name: item.logo,
                width: 70,
                height: 70,
                color: ""
              }, null, 8, ["name"]),
              _createElementVNode("div", _hoisted_29, _toDisplayString(item.title), 1),
              _createElementVNode("div", _hoisted_30, _toDisplayString(item.content), 1),
              _createElementVNode("div", _hoisted_31, _toDisplayString(item.content2), 1)
            ]),
            _createElementVNode("div", _hoisted_32, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.docList, (subTtem, subIndex) => {
                return (_openBlock(), _createBlock(_component_el_button, {
                  key: subIndex,
                  onClick: subTtem.func
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(subTtem.name), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ])
          ])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_33, [
      _createElementVNode("div", _hoisted_34, [
        _createElementVNode("div", _hoisted_35, _toDisplayString(_unref(t)('accessProcess')), 1),
        _createElementVNode("div", _hoisted_36, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(processList, (item, index) => {
            return _createElementVNode("div", {
              key: index,
              class: "flex justify-center items-center"
            }, [
              _createElementVNode("div", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, [
                  _createVNode(_component_svg_icon, {
                    name: item.logo,
                    width: 34,
                    height: 34,
                    color: ""
                  }, null, 8, ["name"])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("div", _hoisted_40, _toDisplayString((index+1+'').padStart(2,'0')), 1),
                  _createElementVNode("div", _hoisted_41, _toDisplayString(item.content), 1)
                ])
              ]),
              (!item.islast)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42))
                : _createCommentVNode("", true)
            ])
          }), 64))
        ])
      ]),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(t)('ifNeedHelp')), 1),
        _createVNode(_component_el_button, {
          style: _normalizeStyle({color:customColor.opSecondary }),
          onClick: jumpToQs
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('helpCenter')), 1)
          ]),
          _: 1
        }, 8, ["style"])
      ])
    ])
  ]))
}
}

})